export function isMobileDevice(excludeTablets = false) {
  if (navigator.userAgentData) {
    return navigator.userAgentData.mobile ?? false;
  }

  // Fallback for Firefox/Safari
  const ua = navigator.userAgent;

  // Exclude tablets
  if (excludeTablets && /iPad|Android(?!.*Mobile)/i.test(ua)) {
    return false;
  }

  return /Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}
